"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axisLabelFormatterOptions = _interopRequireDefault(require("../label-formatters/axis-label-formatter-options"));

var _barClickEvent = _interopRequireDefault(require("./bar-click-event"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _mwChartOneSeriesBarOptions = _interopRequireDefault(require("./mw-chart-one-series-bar-options"));

var _mwChartOneSeriesBarTooltipOptions = _interopRequireDefault(require("./mw-chart-one-series-bar-tooltip-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

var _styles = require("../styles");

function mapBarNames(chartData) {
  return chartData.data.map(function (point) {
    return point.key;
  });
}

function mapBarValuesAndColors(chartData, barColorFormatter) {
  return chartData.data.map(function (point) {
    var color = barColorFormatter(point);
    return {
      // eslint-disable-next-line  id-length
      y: point.value,
      color: color
    };
  });
}

function dataLabelsFormatterWrapper(point, barLabelFormatter) {
  return barLabelFormatter({
    key: point.category,
    value: point.total
  });
}

function legendItemSetToHighchartSeriesSet(legendItemSet, barValues) {
  /*
      barValues are only assigned to the first series because this is purely
      for handling legends - and we only need one series with data
  */
  return legendItemSet.map(function (legendItem, index) {
    var data = [];

    if (index === 0) {
      data = barValues;
    }

    return {
      name: legendItem.label,
      color: legendItem.color,
      data: data
    };
  });
}

var AXIS_LABEL_FONT_WEIGHT = '400';
var AXIS_LABEL_TEXT_OVERFLOW = 'none';
var AXIS_LABEL_WHITE_SPACE = 'nowrap';
var BAR_DATA_LABEL_ALIGN = 'left';
var BAR_LABEL_FONT_WEIGHT = '500';
var BAR_WIDTH = 24;
var CHART_FONT_FAMILY = '"helvetica neue", helvetica, arial, sans-serif';
var CHART_FONT_SIZE = '11px';
var CURSOR_DEFAULT = 'default';
var CUSROR_POINTER = 'pointer';
var HIDDEN = 0;
var HIDE_TITLE = '';
var LEGEND_CURSOR_STYLE = 'default';
var LEGEND_FONT_WEIGHT = 'normal';

var LEGEND_ITEM_CLICK_NOOP = function LEGEND_ITEM_CLICK_NOOP() {
  return false;
};

var STACKED_BARS = 'normal';
var TOOLTIP_BACKGROUND_COLOR = 'rgba(247, 257, 247, 1)'; // This turns the opacity off. The default alpha is 0.85

var YAXIS_LINE_WIDTH = 1;
var YAXIS_LABEL_POSITION_OFFSET = -5;
var YAXIS_TITLE_SUMMARY_OFFSET = 15;
var YAXIS_TITLE_DETAIL_OFFSET = 30;
/**
 * A class for rendering a bar chart with a singe series of data
 * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
 */

var MwChartOneSeriesBar =
/*#__PURE__*/
function () {
  function MwChartOneSeriesBar(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartOneSeriesBar);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {SeriesData} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartOneSeriesBar, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      this.__chartData = (0, _coerce.default)(chartData, _seriesData.default, "chartData should be shaped like a SeriesData. Provided value: ".concat(JSON.stringify(chartData)));
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartOneSeriesBarOptions} chartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(chartOptions) {
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartOneSeriesBarOptions.default, "chartOptions should be shaped like a MwChartOneSeriesBarOptions. Provided value: ".concat(JSON.stringify(_mwChartOneSeriesBarOptions.default)));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      var safeChartOptions = this.__chartOptions;
      var barNames = mapBarNames(this.__chartData);
      var barValues = mapBarValuesAndColors(this.__chartData, safeChartOptions.barColorFormatter);
      var series;

      if (safeChartOptions.legendItemSet) {
        series = legendItemSetToHighchartSeriesSet(safeChartOptions.legendItemSet, barValues);
      } else {
        series = [{
          data: barValues
        }];
      }

      var dataLabelsFormatter = function dataLabelsFormatter() {
        // eslint-disable-next-line no-invalid-this
        return dataLabelsFormatterWrapper(this.point, safeChartOptions.barLabelFormatter);
      };

      var yAxisGridLineWidth = 1;
      var yAxisTitleOffset = YAXIS_TITLE_DETAIL_OFFSET;

      if (safeChartOptions.showSummaryYAxis) {
        yAxisTitleOffset = YAXIS_TITLE_SUMMARY_OFFSET;
        yAxisGridLineWidth = 0;
      }

      var enableLegend = false;

      if (safeChartOptions.legendItemSet) {
        enableLegend = true;
      }

      var yAxisTitleEnabled = false;

      if (safeChartOptions.yAxisTitle) {
        yAxisTitleEnabled = true;
      }

      var valueLabelFormatter;

      if (safeChartOptions.yAxisLabelFormatter) {
        valueLabelFormatter = function valueLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value || '0'
            /* eslint-enable no-invalid-this */

          });

          if (safeChartOptions.showSummaryYAxis) {
            /* eslint-disable no-invalid-this */
            if (this.isFirst || this.isLast) {
              return safeChartOptions.yAxisLabelFormatter(options);
            }
            /* eslint-enable no-invalid-this */

          } else {
            return safeChartOptions.yAxisLabelFormatter(options);
          }
        };
      }

      var onBarClick;
      var barCursorStyle = CURSOR_DEFAULT;

      if (safeChartOptions.onBarClick) {
        onBarClick = function onBarClick(_ref) {
          var point = _ref.point;
          var barClickEvent = new _barClickEvent.default({
            /* eslint-disable no-invalid-this */
            key: point.category,
            value: point.y
            /* eslint-enable no-invalid-this */

          });
          return safeChartOptions.onBarClick(barClickEvent);
        };

        barCursorStyle = CUSROR_POINTER;
      }

      var tooltipFormatter = function tooltipFormatter() {
        var options = new _mwChartOneSeriesBarTooltipOptions.default({
          /* eslint-disable no-invalid-this */
          point: this.point,
          series: this.series
          /* eslint-enable no-invalid-this */

        });
        return safeChartOptions.tooltipFormatter(options);
      };

      _highcharts.default.chart(this.__renderTarget, {
        chart: {
          marginRight: 12,
          spacingLeft: 0,
          spacingTop: 0,
          style: {
            fontFamily: _styles.FONT_FAMILY,
            color: _styles.AXIS_LABEL_FONT_COLOR
          },
          type: 'bar'
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: {
          text: HIDE_TITLE
        },
        xAxis: {
          categories: barNames,
          labels: {
            enabled: false
          },
          lineWidth: HIDDEN,
          tickLength: HIDDEN
        },
        yAxis: {
          title: {
            enabled: yAxisTitleEnabled,
            text: safeChartOptions.yAxisTitle,
            margin: 5,
            offset: yAxisTitleOffset,
            style: {
              color: _styles.AXIS_LABEL_FONT_COLOR,
              fontFamily: CHART_FONT_FAMILY,
              fontSize: CHART_FONT_SIZE,
              fontWeight: BAR_LABEL_FONT_WEIGHT
            }
          },
          gridLineColor: _styles.LINE_AND_TICK_COLOR,
          gridLineWidth: yAxisGridLineWidth,
          labels: {
            formatter: valueLabelFormatter,
            style: {
              color: _styles.AXIS_LABEL_FONT_COLOR,
              fontFamily: CHART_FONT_FAMILY,
              fontWeight: AXIS_LABEL_FONT_WEIGHT,
              marginLeft: 0,
              textOverflow: AXIS_LABEL_TEXT_OVERFLOW,
              whiteSpace: AXIS_LABEL_WHITE_SPACE
            },
            // eslint-disable-next-line id-length
            y: YAXIS_LABEL_POSITION_OFFSET
          },
          lineColor: _styles.LINE_AND_TICK_COLOR,
          lineWidth: YAXIS_LINE_WIDTH,
          min: 0,
          opposite: true,
          tickColor: _styles.LINE_AND_TICK_COLOR,
          tickLength: 5,
          tickWidth: 1
        },
        tooltip: {
          backgroundColor: TOOLTIP_BACKGROUND_COLOR,
          borderRadius: 2,
          borderWidth: 2,
          formatter: tooltipFormatter,
          shadow: true,
          shape: 'square',
          shared: false,
          style: {
            padding: 4
          },
          useHTML: true
        },
        legend: {
          enabled: enableLegend,
          itemHoverStyle: {
            color: _styles.LEGEND_LABEL_FONT_COLOR
          },
          itemStyle: {
            color: _styles.LEGEND_LABEL_FONT_COLOR,
            cursor: LEGEND_CURSOR_STYLE,
            fontSize: CHART_FONT_SIZE,
            fontWeight: LEGEND_FONT_WEIGHT
          },
          padding: 0,
          symbolHeight: 8,
          symbolPadding: 3,
          symbolRadius: 4,
          symbolWidth: 8
        },
        plotOptions: {
          bar: {
            animation: safeChartOptions.animate,
            dataLabels: {
              align: BAR_DATA_LABEL_ALIGN,
              enabled: true,
              formatter: dataLabelsFormatter,
              inside: true,
              style: {
                fontFamily: CHART_FONT_FAMILY
              }
            },
            events: {
              click: onBarClick,
              legendItemClick: LEGEND_ITEM_CLICK_NOOP
            },
            pointWidth: BAR_WIDTH
          },
          series: {
            cursor: barCursorStyle,
            stacking: STACKED_BARS
          }
        },
        series: series
      });
    }
  }]);
  return MwChartOneSeriesBar;
}();

exports.default = MwChartOneSeriesBar;